<svg
    class="mr-4"
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
>
    <circle cx="16.5" cy="16.5" r="16.0664" fill="#006699" />
    <text
        x="50%"
        y="50%"
        text-anchor="middle"
        dy=".3em"
        fill="white"
        font-size="16"
    >
        {{ formFieldNumber }}
    </text>
</svg>
